// Where a signed-in person lands. One answer for everyone: parent or teacher,
// new or returning, email or Google. Every login, OAuth return, paywall and
// thank-you redirect asks this file instead of naming a path itself.
//
// This file decides WHERE, never WHO. The landing route keeps its own
// ProtectedRoute requireSubscription guard in App.jsx, so an unpaid account
// sent here still gets the paywall exactly as before.

// The Timo talk screen (src/pages/Timo). /home renders the same screen and now
// redirects here, so old bookmarks keep working.
export const LANDING_ROUTE = '/timo';
export const LOGIN_ROUTE = '/login';
export const ONBOARDING_ROUTE = '/onboarding';
export const HELP_ROUTE = '/help';
export const HELP_ROUTE_ALIAS = '/kaip-naudotis';

// Earlier home screens. The routes stay for bookmarks; nothing links to them.
export const HIDDEN_HOME_ROUTES = Object.freeze(['/home', '/home/classic', '/house', '/parent']);

const isSession = (user) => user !== null && typeof user === 'object' && !Array.isArray(user);

/**
 * @param {{ user?: object|null, hasActiveSubscription?: boolean,
 *           hasCompletedOnboarding?: boolean }} [state]
 * @returns {'/timo'|'/login'|'/onboarding'}
 *
 * Only a literal `true` counts for the two flags: a half-loaded or odd value
 * sends the person through onboarding rather than past it. A teacher and a
 * parent get the same answer; there is no teacher input.
 */
export function getPostLoginRoute(state) {
  const s = state !== null && typeof state === 'object' && !Array.isArray(state) ? state : {};
  if (!isSession(s.user)) return LOGIN_ROUTE;
  if (s.hasActiveSubscription === true) return LANDING_ROUTE;
  if (s.hasCompletedOnboarding === true) return LANDING_ROUTE;
  return ONBOARDING_ROUTE;
}
